<template>
    <div :class="classes">
        <form id="frmPage3" @input="submit">
            <div class="form-section">
                <div class="registration-page-title">Store details</div>
            </div>
            <div class="form-section">
                <div class="form-group w-80">
                    <label>STORE ADDRESS</label>
                    <input id="google_maps_search" ref="maps_search" type="text" placeholder="Start typing your address here and select from the list"
                        class="placeholder-no-fix" aria-describedby="inputGroupPrepend" value="">
                        <!-- <div class="form-inline">Edit this field if your Store Address has changed</div> -->
                        <FormError :validationStatus="v$.address1"/>
                </div>
                <div class="w-flex-80">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover">
                            <label>ADDRESS</label>
                            <div class="input-group-cover">
                                <input readonly type="text" id="address" placeholder="Address 1" name="address" class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend"
                                    v-model="address1">
                            </div>
                        </div>
                    </div>

                    <div class="form-group auto-filled-form" style="margin-left: 2%">
                        <div class="input-group-cover">
                            <label>SUBURB/CITY</label>
                            <div class="input-group-cover">
                                <input readonly type="text" placeholder="Suburb/City" id="suburb" name="suburb" class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="suburb">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-flex-80">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover ">
                            <label>POST/ZIP CODE</label>
                            <div class="input-group-cover">
                                <input readonly type="text" id="zip" placeholder="Post code" name="zip" class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend"
                                    v-model="zip">
                            </div>
                        </div>
                    </div>

                    <div class="form-group auto-filled-form" style="margin-left: 2%">
                        <div class="input-group-cover">
                            <label>STATE/PROVINCE</label>
                            <div class="input-group-cover">
                                <input readonly type="text" placeholder="State/Province" id="state" name="state" class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="state">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-80" style="margin-top: 0px;">
                    <div class="form-group auto-filled-form">
                        <div class="input-group-cover">
                            <label>COUNTRY</label>
                            <div class="input-group-cover">
                                <input readonly id="country_id" name="country" type="text" placeholder="Country" class="placeholder-no-fix non-editable" aria-describedby="inputGroupPrepend" v-model="country">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group w-80">
                    <label>Opening hours</label>
                </div>

                <div class="form-group w-80">
                    <div class="check-group age-checkbox-wrapper">
                        <input type="checkbox" @click="toggleAppointment" class="fg-check" id="by_appointment" name="by_appointment" v-model="byAppointment"> <label for="by_appointment">By Appointment only</label>
                    </div>
                </div>
                <div class="opening-hours-container" v-if="!byAppointment">
                    <div class="form-group w-80">
                        <div class="hours-section-header">
                            <div>-</div>
                            <div style="margin-right: 10px">Open at</div>
                            <div>Closing at</div>
                            <div style="width: 22%;">Closed</div>
                        </div>
                        <div class="form-row business-hours-edit">
                            <div class="hour-detail-left">
                                <div v-for="(day, index) in days" :key="index" class="row m-3 d-flex w-100">
                                    <div class="days-column">{{ day }}</div>
                                    <div class='hours-column'>
                                        <select class="custom-msg-display-new" style="margin-right: 5px;" v-model="storeHours[day]['start_' + day]">
                                            <option v-for="(time, key) in times" :value="key" :key="key" :selected="key === '09:00'? true : false">{{time}}</option>
                                        </select>
                                        <div class="hours-section-dash"> - </div>
                                        <select class="custom-msg-display-new" style="margin-left: 5px;" v-model="storeHours[day]['end_' + day]">
                                            <option v-for="(time, key) in times" :value="key" :key="key" :selected="key === '17:00'? true : false">{{time}}</option>
                                        </select>
                                    </div>
                                    <div class="close-button-column">
                                        <input style='margin-right: 10px; margin-top: -5px;' class='closed_day' type="checkbox" v-model="storeHours[day]['closed_' + day]">
                                    </div>
                                </div>
                            </div>
                            <div class="hours-copy-button-container"><button type="button" class="opening-hours-copy-button" @click="copyOpeningHours"> <span class="glyphicon glyphicon-copy"></span><span>Copy to all</span></button></div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import FormError from './FormError.vue';
export default {
    setup(){
        return { v$: useVuelidate() }
    },
    props: ['days', 'times', 'storeHours','addressType', 'classes', 'formData', 'physicalStore', 'byAppointment'],
    emits: ["update"],
    components: {FormError},
    data(){
        return {
            country: this.formData.country,
            address1: this.formData.address1,
            zip: this.formData.zip,
            suburb: this.formData.suburb,
            state: this.formData.state,
            byAppointment: false
        }
    },
    methods:{
        submit(){
            if(this.addressType != 'Billing'){
                var dataObj = {
                    country: this.country,
                    address1: this.address1,
                    zip: this.zip,
                    suburb: this.suburb,
                    state: this.state,
                    billingCountry: this.country,
                    billingAddress1: this.address1,
                    billingZip: this.zip,
                    billingSuburb: this.suburb,
                    billingState: this.state,
                    byAppointment: this.byAppointment,
                    storeHours: this.storeHours 
                }
            }else{
                var dataObj = {
                    country: this.country,
                    address1: this.address1,
                    zip: this.zip,
                    suburb: this.suburb,
                    state: this.state,
                    byAppointment: this.byAppointment,
                    storeHours: this.storeHours 
                }
            }
            this.$emit('update', {
                data: dataObj,
                valid: !this.v$.$invalid
            });
        },
        toggleAppointment(){
            this.byAppointment = !this.byAppointment
        },
        copyOpeningHours(){
            for(var key in this.storeHours) {
                this.storeHours[key]['start_'+key] = this.storeHours['Monday']['start_Monday'];
                this.storeHours[key]['end_'+key] = this.storeHours['Monday']['end_Monday'];
                this.storeHours[key]['closed_'+key] = this.storeHours['Monday']['closed_Monday'];
            }
        }

    },
    mounted() {
        const autocomplete = new google.maps.places.Autocomplete(this.$refs['maps_search']);
        autocomplete.setComponentRestrictions({'country': this.formData.countryCode});
        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();

            for (let i = 0; i < place.address_components.length; i++) {
                const component = place.address_components[i];

                if (component.types.includes('country')) {
                    this.country = component.long_name;
                } else if (component.types.includes('postal_code')) {
                    this.zip = component.long_name;
                } else if (component.types.includes('postal_town') || component.types.includes('locality') || component.types.includes('sublocality') || component.types.includes('administrative_area_level_4')) {
                    this.suburb = component.long_name;
                } else if (component.types.includes('administrative_area_level_1')) {
                    this.state = component.long_name;
                } else if (component.types.includes('street_number')) {
                    this.address1 = component.long_name;
                } else if (component.types.includes('route')) {
                    this.address1 += ' ' + component.long_name;
                }
            }

            this.submit();
        })
    },
    validations:{
        country: {required},
        address1: {required},
        zip: {required},
        suburb: {required},
        state: {required},
    }  
}
</script>